import { useDispatch, useSelector } from 'react-redux';
import { selectIsSuper } from 'src/store/selectors/userInfo';
import { useCallback, useEffect } from 'react';
import { selectShowEntityInspector } from 'src/store/selectors/entityInfoSelectors';
import { setShowEntityInspector } from 'src/store/actions/entityInfoActions';
export default function useEntityInspectorListener() {
    const dispatch = useDispatch();
    const listenerEnabled = useSelector(selectIsSuper);
    const inspectorShown = useSelector(selectShowEntityInspector);
    const onKeyPress = useCallback((e) => {
        const keysPressed = e.altKey && e.shiftKey;
        if (keysPressed) {
            dispatch(setShowEntityInspector(true));
            e.preventDefault();
        }
        else if (inspectorShown && !keysPressed) {
            dispatch(setShowEntityInspector(false));
        }
    }, [dispatch, inspectorShown]);
    useEffect(() => {
        if (listenerEnabled) {
            window.addEventListener('keydown', onKeyPress);
            window.addEventListener('keyup', onKeyPress);
        }
        return () => {
            window.removeEventListener('keydown', onKeyPress);
            window.removeEventListener('keyup', onKeyPress);
        };
    }, [listenerEnabled, onKeyPress]);
}
